import Service from 'vuex-service-api';
import { Api } from "vuex-skin-generator-service-api";
import ServiceSSO from 'vuex-sso-service-api';

export const service = new Service({
  baseURL: process.env.API_HOST,
  tocken: process.env.API_TOCKEN,
});

export function service_Skin(options) {
  let baseUrl = process.env.API_HOST_GO;
  let headers = {
    "Content-Type": "application/json",
    Authorization: window.ApiToken
      ? window.ApiToken
      : "Bearer " + process.env.API_TOCKEN_Go
  };
  if (options.user) {
    headers["X-Tenant-USER"] = options.user;
  }

  let baseApiParams = {
    credentials: "same-origin",
    headers: headers,
    redirect: "follow"
  };
  return new Api({
    baseUrl: baseUrl,
    baseApiParams: baseApiParams
  });
}



export const Service_SSO = new ServiceSSO({
  baseURL: process.env.API_SAML,
  tocken: process.env.API_TOCKEN,
});





// WEBPACK FOOTER //
// ./src/service/index.js